export const banks = (state) => state.banks;
export const assets = (state) => state.assets;
export const income = (state) => state.income;
export const listForms = (state) => state.forms;
export const donations = (state) => state.donations;
export const singleForm = (state) => state.single_form;
export const liabilities = (state) => state.liabilities;
export const expenditures = (state) => state.expenditures;